import styled from "styled-components";
import { Paper } from "@mui/material";
import { deviceSpec } from "breakpoints";

export const LoginPage = styled("div")`
  background-color: ${({ theme }) => theme.colors.darkGrey} !important;

  display: flex;
  
  @media ${deviceSpec.isDesktop} {
    flex-direction: row;
  }

  @media ${deviceSpec.isLaptop} {
    flex-direction: column;
  }

  // The theme cannot affect this page
  p, span, strong, a, h1, h2, h3, h4, h5, h6 {
    color: white !important;
  }

  .MuiPaper-root {
    background-color: #191919;
  }

  .MuiSvgIcon-root {
    color: white !important;
  }
`;

export const LoginContainer = styled("div")`
  padding: 2rem;
  width: 66%;
  height: max-content;
  // background-color: ${({ theme }) => theme.colors.loginCardBackground};

  p,
  a {
    font-family: Poppins !important;
  }

  h3 {
    font-weight: 550;
  }

  button {
    border-radius: 5px;
    background-color: ${({ theme }) => theme.colors.loginBackgroundIdle};

    div:nth-child(2) {
      width: 100%;
    }

    div {
      border-radius: 5px;
    }
  }

  button:active {
    background-color: ${({ theme }) => theme.colors.loginBackgroundActive};
  }

  button:hover {
    background-color: ${({ theme }) => theme.colors.loginBackgroundHover};
  }
`;

export const LoginLogoHeader = styled("div")`
  h3 {
    font-weight: 600;
  }
`;

export const LoginSummary = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: center;

  a,
  p {
    font-size: ${({ theme }) => theme.font.xl};
    width: max-content;
  }
`;

export const LoginDisclaimer = styled("div")`
  display: flex;
  white-space: pre;
  flex-wrap: wrap;

  a, p {
    font-size: ${({ theme }) => theme.font.xl};
  }

  p {
    width: max-content
    display: block;
  }
  
  a {
    text-decoration: underline;
  }

  a:hover {
    color: ${({ theme }) => theme.colors.highlight1};
  }
`;

export const LoginHeading = styled("div")`
  font-weight: 600;
  margin-bottom: 1.25rem;
  text-align: center;
  font-family: Poppins !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media ${deviceSpec.isDesktop} {
    margin-top: 0;
  }

  @media ${deviceSpec.isLaptop} {
    margin-top: 3.75rem;
  }
`;

export const LoginButton = styled("button")`
  button {
    cursor: pointer;
  }
`;

export const LoginInformationSection = styled("div")`
  display: grid;
  grid-template-rows: 10% 80% 10%;
  background: linear-gradient(
    to right,
    #4e0076 10%,
    ${({ theme }) => theme.colors.darkGrey} 100%
  );

  h1 {
    font-size: ${({ theme }) => theme.font.h1};
  }

  h2 {
    font-size: ${({ theme }) => theme.font.h2};
  }

  h3 {
    font-size: ${({ theme }) => theme.font.h3};
  }

  h4 {
    font-size: ${({ theme }) => theme.font.h4};
  }

  // @media ${deviceSpec.isTablet} {
  //   padding-bottom: 5rem;
  // }
`;

export const Logo = styled("span")<{ size: string }>`
  svg {
    height: ${({ size, theme }) => {
      switch (size) {
        case "full":
          return "max-content";
        case "xl":
          return theme.font.h1;
        case "large":
          return theme.font.h2;
        case "medium":
          return theme.font.h3;
        case "small":
          return theme.font.h4;
        default:
          return theme.font.h2;
      }
    }};
    width: 100%;
  }
`;

export const LoginCarouselContainer = styled('div')`
  flex: 1 1;

  @media ${deviceSpec.isDesktop} {
    padding: 2rem;
  }

  @media ${deviceSpec.isLaptop} {
    padding: 4rem;
  }

  @media ${deviceSpec.isMobile} {
    padding: 1rem;
  }
`
